import React from "react";
import { LoadingIcon } from "../../../../components/Loading";
import { keylessColors } from "../../utils";

export function KeylessReturnFooter({
  primaryText,
  primaryOnClick,
  primaryLoading,
  primaryDisabled,
  secondaryText,
  secondaryOnClick,
  secondaryLoading,
  secondaryDisabled,
  showSecondary = true,
}) {

  return (
    <div style={styles.container}>
      <ReturnButton
        text={primaryText}
        onClick={primaryOnClick}
        isLoading={primaryLoading}
        disabled={primaryDisabled}
        color={primaryDisabled ? "#999" : "white"}
        backgroundColor={primaryDisabled ? "#D9D9D9" : keylessColors.orange}
      />
      {showSecondary && (
        <ReturnButton
          text={secondaryText}
          onClick={secondaryOnClick}
          isLoading={secondaryLoading}
          disabled={secondaryDisabled}
          color={secondaryDisabled ? "#777" : "white"}
          backgroundColor={secondaryDisabled ? "#C0C0C0" : "#30303099"}
        />
      )}
    </div>
  );
}

function ReturnButton({ text, color, backgroundColor, onClick, isLoading, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled || isLoading}
      style={{
        ...styles.button,
        color,
        backgroundColor,
        opacity: disabled ? 0.7 : 1,
        pointerEvents: disabled || isLoading ? "none" : "auto",
      }}
    >
      {isLoading ? <LoadingIcon /> : null}
      {text}
    </button>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
  },
  button: {
    width: "100%",
    height: "7vh",
    borderRadius: "8px",
    fontSize: "1.2rem",
    outline: "none",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    cursor: "pointer",
  },
};
